export const serviceName = 'tarpulator';
